export const SHOW_OVERLAY = 'SHOW_OVERLAY'
export const HIDE_OVERLAY = 'HIDE_OVERLAY'

export interface OverlayState {
  isVisible: boolean
  title?: string
}

export interface ShowOverlayAction {
  type: typeof SHOW_OVERLAY
  isRealtime: false
  payload: {
    isVisible: true
    title?: string
  }
}

export interface HideOverlayAction {
  type: typeof HIDE_OVERLAY
  isRealtime: false
  payload: {
    isVisible: false
  }
}

export type OverlayActionTypes = ShowOverlayAction | HideOverlayAction
